export const todayDateTime = () => {
  const D = new Date()
  const y = D.getFullYear()
  const m = D.getMonth() + 1
  const d = D.getDate()
  let h = D.getHours()
  let min = D.getMinutes()
  if (h < 10) {
    h = '0' + h
  }
  if (min < 10) {
    min = '0' + min
  }
  return `${d}. ${m}. ${y}, ${h}:${min} hod` // 16. 6. 2022, 15:46 hod
}

export const todayDate = () => {
  return new Date().toLocaleDateString()  // 16. 6. 2022
}

export const dateFromDate = (d) => {
  return new Date(d).toLocaleDateString()  // 16. 6. 2022
}

export const todayISODate = () => {
  const d = new Date()
  return d.toISOString().split('T')[0]  // 2022-06-16
}

export const todayISODateOff = (offset, what = 'd') => {
  const d = new Date()
  if (what === 'd') {
    d.setDate(d.getDate() + offset)
  } else {
    d.setMonth(d.getMonth() + offset)
  }
  return d.toISOString().split('T')[0]  // 2022-06-16 + offset
}



// WEBPACK FOOTER //
// ./src/utils/datesTimes.js